export default class FortuneApplication {
    id: number;
    chatRoomId?: number;
    name?: string;

    constructor(data?: Partial<FortuneApplication>) {
        Object.assign(this, data);
    }
}
